import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchSocialLinks = createAsyncThunk(
    'socialLinks/fetchSocialLinks',
    async (language, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/social-links`, {
                headers: {
                    'Accept-Language': language || 'ar'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch social links');
        }
    }
);
